/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_3_AInputs */

const en_mk_how_3_a = /** @type {(inputs: Mk_How_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose cloud or your computer, then the AI source for coding`)
};

const id_mk_how_3_a = /** @type {(inputs: Mk_How_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih cloud atau komputer sendiri, lalu sumber AI untuk coding`)
};

/**
* | output |
* | --- |
* | "Choose cloud or your computer, then the AI source for coding" |
*
* @param {Mk_How_3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_3_a = /** @type {((inputs?: Mk_How_3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_3_a(inputs)
	return en_mk_how_3_a(inputs)
});